import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const { data } = await api.get("/categories");
    setCats(data);
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      await api.post("/categories", { name });
      setName("");
      toast.success("Category added.");
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed."); }
    setSaving(false);
  };

  const remove = async (id, catName) => {
    if (!window.confirm(`Delete category "${catName}"?`)) return;
    try {
      await api.delete(`/categories/${id}`);
      toast.success("Deleted.");
      load();
    } catch { toast.error("Failed."); }
  };

  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-wider text-blue-600">Taxonomy</div>
      <h1 className="mt-1 font-display text-3xl font-bold">Categories</h1>

      <form onSubmit={add} className="mt-6 flex gap-2 max-w-md" data-testid="category-form">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="New category name" data-testid="category-input" className="flex-1 px-4 py-2.5 rounded-lg border border-slate-200 bg-white text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none" />
        <button disabled={saving} data-testid="category-add" className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-lg bg-slate-900 text-white font-medium text-sm hover:bg-blue-600 disabled:opacity-60">
          <Plus className="w-4 h-4" /> Add
        </button>
      </form>

      <div className="mt-8 rounded-2xl bg-white border border-slate-200 divide-y divide-slate-100 max-w-2xl" data-testid="category-list">
        {cats.length === 0 ? (
          <div className="p-10 text-center text-sm text-slate-500">No categories yet.</div>
        ) : cats.map(c => (
          <div key={c.id} className="flex items-center justify-between px-5 py-3" data-testid={`category-row-${c.slug}`}>
            <div>
              <div className="font-medium text-slate-900">{c.name}</div>
              <div className="text-xs text-slate-500 font-mono">{c.slug}</div>
            </div>
            <button onClick={() => remove(c.id, c.name)} className="p-2 rounded-lg hover:bg-rose-50 text-rose-600" data-testid={`category-delete-${c.slug}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
